import Icon from "@pathccm/rula-ui/icon";
import { ReactNode, useEffect } from "react";
import { Button, Modal, ModalOverlay } from "react-aria-components";
import React from "react";

export const SlideUpModal = ({
  isOpen,
  onOpenChange,
  title,
  children,
  footer,
  autoFocusCloseButton = false
}: {
  isOpen: boolean;
  onOpenChange: () => void;
  children?: ReactNode;
  title?: string;
  footer?: ReactNode;
  autoFocusCloseButton?: boolean
}) => {
  useEffect(() => {
    const handleEscPressed = (event) => {
      if (event.key === "Escape") {
        onOpenChange()
      }
    };

    document.addEventListener('keydown', handleEscPressed);

    return () => {
      document.removeEventListener('keydown', handleEscPressed);
    };
  }, [])

  return (< ModalOverlay
    className="slide-up-modal-overlay"
    isOpen={isOpen}
    onOpenChange={onOpenChange}
    isDismissable
  >
    <Modal className="slide-up-modal">
      <div className="slide-up-modal-header">
        {title && <div>{title}</div>}
        <Button
          aria-label="Close"
          onPress={onOpenChange}
          className="slide-up-modal-close-button"
          autoFocus={autoFocusCloseButton}
        >
          <Icon icon="X" size="large" aria-hidden={true} />
        </Button>
      </div>
      {children && <div>{children}</div>}
      {footer && <footer className="slide-up-modal-footer">{footer} </footer>}
    </Modal>
  </ModalOverlay >
  )
};
